/**
 *  org-idaas-aggr
 *  @swagger http://org-idaas-aggr.earth.xpaas.lenovo.com/doc.html#/home
 */
import { IAjaxConfig } from '../libraries';
export class EnumApiLiveMudusvr {
  /**
   * @dec 是否允许游客访问
   */
  readonly live_mudu_isTouristVisits: IAjaxConfig = {
    url: '/api/gateway/bp-live-mudu/public/api/isTouristVisits',
    method: 'get',
  };

  /**
   * @dec 校验是否允许访问
   */
  readonly live_mudu_userAuthCheck: IAjaxConfig = {
    url: '/api/gateway/bp-live-mudu/public/api/userAuthCheck',
    method: 'get',
  };

  /**
   * @dec 记录访问日志
   */
  readonly live_mudu_log_save: IAjaxConfig = {
    url: '/api/gateway/bp-live-mudu/public/api/access/log/save',
    method: 'get',
  };

  /**
   * @dec 获取重定向地址
   */
  readonly live_mudu_getGoodsUrl: IAjaxConfig = {
    url: '/api/gateway/bp-live-mudu/public/api/getGoodsUrl',
    method: 'get',
  };
}
